import React from "react";
import cx from "classnames";
import { Icon, infoFill, warningFill } from "Icons/index";

const WarningBanner = ({
  fullWidth = false,
  msg,
  title,
  color = "yellow",
  info = false,
  onClick = () => {},
  className,
}) => {
  const textClasses = cx("text-sm", {
    ["text-[--yellow-d30]"]: color === "yellow",
    ["text-white"]: color === "red",
    ["text-[--green]"]: color === "green",
    ["text-[--accent-d30]"]: color === "blue",
    ["text-[--yellow]"]: color === "yellow-text",
    ["text-[--red]"]: color === "light-red",
  });

  return (
    <div
      className={cx(
        "w-auto min-h-8 rounded p-2 flex items-start gap-2 overflow-hidden",
        {
          ["bg-[--yellow-l35]"]: color === "yellow",
          ["bg-[--red]"]: color === "red",
          ["bg-[#29c36930]"]: color === "green",
          ["bg-[--accent-l35]"]: color === "blue",
          ["bg-[#e4554830]"]: color === "light-red",
          [fullWidth ? "w-full" : "max-w-max"]: true,
        },
        className,
      )}
      onClick={onClick}
    >
      <Icon
        className={cx("opacity-[.75]", {
          ["icon-accent"]: color === "blue",
          ["icon-yellow"]: color === "yellow-text",
          ["icon-white"]: color === "red",
          ["icon-red"]: color === "light-red",
          ["icon-green"]: color === "green",
        })}
        svg={info ? infoFill : warningFill}
        width="1.25rem"
        height="1.25rem"
      />
      <div className="flex flex-col self-center">
        {title && <div className="text-xs font-semibold mb-1 text-[--accent-d30] uppercase">{title}</div>}

        {typeof msg === "string" ? (
          <div className={textClasses} dangerouslySetInnerHTML={{ __html: msg }}></div>
        ) : (
          <div className={textClasses}>{msg}</div>
        )}
      </div>
    </div>
  );
};

export default WarningBanner;
